import dom from '../lib/dom';
import { toArray } from 'lodash';
import { elHTML } from '../config/vars';


const tabLinkSelector = 'consent__details__tab--link';
const tabContentSelector = 'consent__details__tab--content';

export default class CookieConsent {

  constructor(el) {

    if (typeof window.consent === 'undefined') {
        
        return;
    }
    this.cookieFooter = el;
    this.consent = window.consent.cookie;
    this.userSelected = {};    
    this.isMobile = elHTML.classList.contains('is-ios') || elHTML.classList.contains('is-android');
    this.inputs = [];

    if (window.consent.prompt) {

      this.saveCookies = el.querySelector('.consent__save');
      this.saveAllCookies = el.querySelector('.consent__save-all');
      this.cookieDetails = el.querySelector('.consent__details');
      this.cookieTabs = el.querySelector('.consent__details__tab');
      this.cookieElements = el.querySelector('.consent__elements');
      this.cookieDetailsBtn = el.querySelector('.consent__elements--details a');
      this.classes = window.consent.classes;
      this.initialize();
    }
  }

  initialize() {

    this.classes.forEach((el, index) => {
      const span = dom.create('span', {}, []);
      const spanIcon = dom.create('span', {}, []);
      span.innerHTML = el.title;
      spanIcon.innerHTML = '<i class="input"></i>';

      const label = dom.create('label', {
        for: `${el.class}-field`
      }, [spanIcon, span]);

      const input = dom.create('input', {
        type: 'checkbox',
        name: `${el.class}-field`,
        value: el.class
      }, []);

      if (el.hasConsented) {
        input.setAttribute('checked', 'checked');
        this.userSelected[el.class] = true;
      } else {
        this.userSelected[el.class] = false;
      }
      if (!el.canModify) {
        input.setAttribute('disabled','disabled');
      }
      this.inputs.push(input);

      const checkBoxWrapper = dom.create('div', {
        class: 'consent__elements--box formfield-wrapper is-checkbox'
      }, [input, label]);

      checkBoxWrapper.addEventListener('click', this.toggleCheckbox.bind(this, input), false);
      this.cookieElements.appendChild(checkBoxWrapper);

      if (!this.isMobile) {
        const tab = dom.create('button', {
          class: `${tabLinkSelector} ${index === 0 ? 'active' : ''}`,
          'data-tab-id': el.class
        });
  
        tab.innerHTML = `${el.title} (${Object.keys(el.cookies).length})`;
        tab.addEventListener('click', this.toggleTab.bind(this));
        this.cookieTabs.appendChild(tab);
  
        const tabContent = dom.create('table', {
          class: `${tabContentSelector} ${index === 0 ? 'active' : ''}`,
          id: el.class
        });
  
        tabContent.innerHTML = Object.keys(el.cookies).length ? '<tr><th>Name</th><th>Description</th></tr>' : '';
  
        Object.keys(el.cookies).forEach(key => {
          tabContent.innerHTML += `<tr><td><strong>${key}</strong></td><td>${el.cookies[key]}</td></tr>`;
        });
  
        this.cookieDetails.appendChild(tabContent);
      }
    });

    this.registerEvents();
    this.cookieFooter.style.display = 'block';
  }

  registerEvents () {

    this.cookieDetailsBtn.addEventListener('click', this.toggleDetails.bind(this));
    this.saveCookies.addEventListener('click', this.setCookie.bind(this));
    this.saveAllCookies.addEventListener('click', this.setAllCookies.bind(this));
  }

  toggleCheckbox (input) {

    if (input.getAttribute('checked')) {
      input.removeAttribute('checked');
      this.userSelected[input.value] = false;
    } else {
      input.setAttribute('checked', 'checked');
      this.userSelected[input.value] = true;
    }
  }

  toggleDetails (e) {

    if (e.preventDefault) {

      e.preventDefault();
    }

    if (this.isMobile) {

      window.open(window.consent.infoUrl, '_blank');
    } else {

      this.cookieDetailsBtn.classList.toggle('is-open');
      this.cookieDetails.classList.toggle('is-active');
    }
  }

  toggleTab (e) {
    
    if (e.preventDefault) {
      e.preventDefault();
    }

    toArray(this.cookieTabs.querySelectorAll(`.${tabLinkSelector}`)).forEach(el => {
      if (el.classList.contains('active')) {
        el.classList.remove('active');
      }
    });

    toArray(this.cookieDetails.querySelectorAll(`.${tabContentSelector}`)).forEach(el => {
      if (el.classList.contains('active')) {
        el.classList.remove('active');
      }
    });

    e.target.classList.add('active');
    this.cookieDetails.querySelector(`#${e.target.dataset.tabId}`).classList.add('active');
  }

  setCookie () {

    const cookieValue = [];
    Object.keys(this.userSelected).forEach(key => {
      if (this.userSelected[key]) {
        cookieValue.push(key);
      }
    });

    document.cookie = `${this.consent.name}=${cookieValue.join(' ')};max-age=${this.consent.ttl};domain=${this.consent.domain};path=/`;
    this.cookieFooter.style.display = 'none';
  }
  
  setAllCookies() {
    
    this.inputs.forEach(input => {
        
      if(!input.checked) {
        
        this.toggleCheckbox(input);
      }
    });    
    this.setCookie();
  }
};
